import React from 'react'
import {NavLink} from 'react-router-dom'

const Header = () => {
    return (
       <>
       <nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container">
    <NavLink  className="navbar-brand" to="#">My Country</NavLink>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mx-auto me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <NavLink exact activeClassName="menu-active" className="nav-link active" aria-current="page" to="/">Pakistan</NavLink>
        </li>
        <li className="nav-item">
          <NavLink exact activeClassName="menu-active" className="nav-link" to="/punjab">Punjab</NavLink>
        </li>
        <li className="nav-item">
          <NavLink exact activeClassName="menu-active" className="nav-link" to="/karachi">Sindh</NavLink>
        </li>
        <li className="nav-item">
          <NavLink exact activeClassName="menu-active" className="nav-link" to="/khyber">Khyber</NavLink>
        </li>
        <li className="nav-item">
          <NavLink exact activeClassName="menu-active" className="nav-link" to="/balochistan">Balochistan</NavLink>
        </li>
      </ul>
    </div>
  </div>
</nav>
       </>
    )
}

export default Header
